// SavePromoter.jsx
"use client";

import { useEffect } from "react";

const SavePromoter = ({ promoter, eventId }) => {
  useEffect(() => {
    console.log(promoter);
    
    // Only update if a valid promoter is provided (i.e. not null or undefined)
    if (promoter != null && promoter !== "" && eventId) {
      const data = { promoter, eventId };
      localStorage.setItem("promoterData", JSON.stringify(data));
    }
  }, [promoter, eventId]);

  return null;
};

export default SavePromoter;
